/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Grid, Paper, Alert, TextField, InputAdornment } from "@mui/material";

import { useSelector } from "react-redux";
import { useFormik, FormikProvider, Form } from "formik";
// import { useNavigate } from "react-router-dom";
import Loader from "../../loader/loader";
import AlertMsg from "../../common/alert";
import useApiState from "../common/useApiState";
import FormButtons from "../counter/buttons";
import { labels } from "../../../lang/labels";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../counter/generate-receipt/custom-form-grid";
import FormTitle from "../../form-fields/form-title";
import TextInput from "../../form-fields/text-input";
import DashBoardContainer from "../../layout/dashboard-container";
import {
  getPropertyDetails,
  updatePropertyDetails,
} from "../../../services/property-details";
import {
  AccountBox,
  Edit,
  Email,
  Home,
  LocationOn,
  PhoneAndroid,
} from "@mui/icons-material";
import { getErrorMsg } from "../../../utils/helpers";
import { showToastError, showToastSuccess } from "../../common/toastHelper";

const AddMobileNumberToProperty = () => {
  // const navigate = useNavigate();
  const initialState = {
    propertyCode: "",
    ownerName: "",
    propertyAddress: "",
    oldMobileNumber: "",
    oldEmail: "",
    newMobileNumber: "",
    newEmail: "",
  };
  const [propertyData, setPropertyData] = useState("");
  const { loading, setLoading, error, setError, success, setSuccess } =
    useApiState();
  const lang = useSelector((state) => state.userDetails.lang);
  const formik = useFormik({
    initialValues: initialState,
  });
  const { setValues } = formik;

  const handleSubmitButtonClick = async (e) => {
    e.preventDefault();
    const body = {
      propertyCode: formik.values.propertyCode,
      mobileNo: formik.values.newMobileNumber,
      emailId: formik.values.newEmail,
    };
    try {
      setLoading(true);
      const response = await updatePropertyDetails(body);
      showToastSuccess("Mobile/Email updated successfully");
    } catch (error) {
      showToastError(getErrorMsg(error));
    } finally {
      setLoading(false);
    }
  };

  const resetStateData = () => {
    window.location.reload();
  };

  const handleFieldChange = (event) => {
    const { name, value } = event.target;
    if (name === "propertyCode" && value === "") {
      setValues(() => ({
        ...initialState,
      }));
    }
  };

  const handleBlur = async (e) => {
    const { name, value } = e.target;

    if (name === "propertyCode" && value && !formik?.errors?.propertyCode) {
      try {
        setError("");
        setLoading(true);
        const res = await getPropertyDetails(value);
        setPropertyData(res);
      } catch (error) {
        setPropertyData("");
        showToastError(getErrorMsg(error));
      } finally {
        setLoading(false);
      }
    } else if (name === "propertyCode" && value === "") {
      setValues(() => ({
        ...initialState,
      }));
    }
  };

  return (
    <DashBoardContainer>
      <FormikProvider value={formik}>
        <Form>
          {success && <Alert severity="success">{success}</Alert>}
          {loading && <Loader />}
          {error && (
            <AlertMsg
              message={error}
              severity="error"
              onClose={() => {
                setError("");
              }}
            />
          )}
          <Paper elevation={4} sx={{ marginBottom: "15px" }}>
            <FormTitle title={labels.addMobTitle[lang]} />
            <Grid>
              <GridRow>
                <FormLabel label={labels.PropertyNumber[lang]} required />
                <FormValue
                  component={
                    <TextInput
                      name="propertyCode"
                      onChange={handleFieldChange}
                      onBlur={handleBlur}
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Home />
                          </InputAdornment>
                        ),
                      }}
                    />
                  }
                />
                <FormLabel label={labels.MalakName[lang]} />
                <FormValue
                  component={
                    <TextInput
                      name="ownerName"
                      value={propertyData.propertyName || ""}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AccountBox />
                          </InputAdornment>
                        ),
                      }}
                    />
                  }
                />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.propertyAddress[lang]} />
                <FormValue
                  component={
                    <TextField
                      name="propertyAddress"
                      multiline
                      minRows={2} // Sets a fixed number of visible rows
                      maxRows={4}
                      variant="outlined" // You can also use 'filled' or 'standard'
                      sx={{
                        width: { xs: "100%", md: "90%" },
                      }}
                      value={propertyData.propertyAddress || ""}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationOn />
                          </InputAdornment>
                        ),
                      }}
                    />
                  }
                />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.oldMobNum[lang]} />
                <FormValue
                  component={
                    <TextInput
                      name="oldMobileNumber"
                      value={propertyData.mobileNo || ""}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PhoneAndroid />
                          </InputAdornment>
                        ),
                      }}
                    />
                  }
                />
                <FormLabel label={labels.oldEmail[lang]} />
                <FormValue
                  component={
                    <TextInput
                      name="oldEmail"
                      value={propertyData.emailId || ""}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Email />
                          </InputAdornment>
                        ),
                      }}
                    />
                  }
                />
              </GridRow>
              <GridRow>
                <FormLabel label={labels.newMobNum[lang]} />
                <FormValue
                  component={
                    <TextInput
                      name="newMobileNumber"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Edit />
                          </InputAdornment>
                        ),
                      }}
                    />
                  }
                />
                <FormLabel label={labels.newEmail[lang]} />
                <FormValue
                  component={
                    <TextInput
                      name="newEmail"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Edit />
                          </InputAdornment>
                        ),
                      }}
                    />
                  }
                />
              </GridRow>
              <Grid container justifyContent="center" alignItems="center">
                <Grid
                  item
                  md={3}
                  container
                  justifyContent={{ md: "flex-end" }}
                  alignItems="center"
                  p={2}
                >
                  <FormButtons
                    isValid={!(formik.isValid && formik.dirty)}
                    handleSubmitButtonClick={handleSubmitButtonClick}
                    resetForm={() => {
                      formik.resetForm();
                      resetStateData();
                    }}
                    submitBtnLabel="Submit"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Form>
      </FormikProvider>
    </DashBoardContainer>
  );
};
export default AddMobileNumberToProperty;
